import { SelectBankAccount } from '@fingo/lib/components/selects';
import PropTypes from 'prop-types';
import React from 'react';
import Stack from '@mui/material/Stack';

const OfferExternalSelectBankAccount = ({ bankId, setBankId }) => (
  <Stack px={3} pb={3}>
    <SelectBankAccount setBankId={setBankId} bankId={bankId} />
  </Stack>
);

OfferExternalSelectBankAccount.propTypes = {
  bankId: PropTypes.number.isRequired,
  setBankId: PropTypes.func.isRequired,
};

export default OfferExternalSelectBankAccount;
